import { Component, Input } from '@angular/core';
import { BookingSlot } from '../../../../booking/models/booking-slot';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-time-period-time-slot',
  templateUrl: './time-period-time-slot.component.html',
  styleUrls: ['./time-period-time-slot.component.css']
})
export class TimePeriodTimeSlotComponent {

  @Input()
  bookingSlot: BookingSlot;

  constructor(
  ) { }

  getHourString(floatTime: number): string {
    return environment.globalSettings.getHourString(floatTime);
  }

  getMinutesString(floatTime: number): string {
    return environment.globalSettings.getMinutesString(floatTime);
  }

}
